import type { FC } from 'react';
import { Button } from '@/DesignSystem/Component';
import { useAppDispatch } from '@/Module/Store/Hook';
import Teacher from '@/Module/Teacher/Component/TeacherList/Teacher';
import { useTeacherList } from '@/Module/Teacher/Hook/useTeacherList';
import type { ITeacherCategoryListCategory } from '@/Module/Teacher/Model/DataModel/ITeacherCategoryList';
import { teacherCategoryNextPageAction } from '@/Module/Teacher/Store/Slice/TeacherCategorySlice';
interface IProps {
  id: ITeacherCategoryListCategory['id'];
}
const TeacherListByCategory: FC<IProps> = ({
  id
}) => {
  const dispatch = useAppDispatch();
  const {
    categoryTeacher,
    isLoading,
    hasMore
  } = useTeacherList(id);
  if (!categoryTeacher?.teacherList?.ids) return null;
  const color = categoryTeacher?.category.color!;
  const onNextPageClick = () => {
    dispatch(teacherCategoryNextPageAction(id));
  };
  return <>
      <div className="grid grid-cols-1 gap-10 sm:grid-cols-2  lg:grid-cols-3 lg:gap-10 ">
        {categoryTeacher?.teacherList?.ids.map(teacherId => <Teacher key={teacherId} teacherId={teacherId} categoryTeacherId={id} color={color} />)}
      </div>

      {hasMore && <Button isLoading={isLoading} className="mt-4 w-full self-center sm:mx-auto sm:mt-10 sm:w-auto" variant="shadow" color={color} radius="circle" size="large" onClick={onNextPageClick}>
          همه معلم ها
        </Button>}
    </>;
};
export default TeacherListByCategory;